import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-lv",
  "use": "icon-flag-lv-usage",
  "viewBox": "0 0 1532 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1532 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-lv\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 1023.983V0h1532.896v1023.983z m1529.792-3.121zM6.31 1017.656h1520.31V6.26H6.31z\" fill=\"#231F20\" p-id=\"1698\" /><path d=\"M3.206 613.84h1526.586v407.022H3.206z\" fill=\"#A12830\" p-id=\"1699\" /><path d=\"M3.206 410.262h1526.586v203.561H3.206z\" fill=\"#FFFFFF\" p-id=\"1700\" /><path d=\"M3.206 3.206h1526.586v407.056H3.206z\" fill=\"#A12830\" p-id=\"1701\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-lv.svg
// module id = /5pr
// module chunks = 24